import { Language } from '@yleisradio/areena-types';
import { getTranslation } from 'services/translations';
import styles from './SearchFooter.module.scss';

interface SearchFooterProps {
  language: Language;
  query: string;
}

export const SearchFooter: React.FunctionComponent<SearchFooterProps> = ({
  language,
  query,
}) => {
  return (
    <div className={styles.search__header}>
      <a
        href={`https://haku.yle.fi/?language=${language}&UILanguage=${language}&q=${query}`}
        className={styles.search__footer__ylesearch}
      >
        {getTranslation('advancedSearch', language)} &gt;
      </a>
    </div>
  );
};
